var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"mr-2 tag text-primary text-wrap",attrs:{"pill":""}},[_c('fa-icon',{staticClass:"mx-1",attrs:{"icon":_vm.icon}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }